import { http } from 'services/http';
import { COMMENTS_GET_MANY } from 'api/query-keys.ts';
import type { TCommentRes, TCreateCommentReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateComment = () => {
  return useMutationBase<TCommentRes, unknown, TCreateCommentReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TCommentRes>('/v1/comments', variables);

      return res.data;
    },

    invalidateCallback: () => [[COMMENTS_GET_MANY]],
  });
};
